import { MantineColor } from "@mantine/core";

export const AREA_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "active": "green.6",
    "inactive": "gray.5",
};

export const AREA_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "bar": "blue.5",
    "club": "violet.5",
    "event_space": "cyan.5",
    "lounge": "teal.5",
    "pool": "lime.5",
    "restaurant": "orange.5",
};

export const BOOKING_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "accepted": "green.6",
    "active": "green.5",
    "advanced": "green.4",
    "booker_advancing": "green.3",
    "cancellation": "yellow.5",
    "cancellation_approved": "yellow.4",
    "cancellation_denied": "red.5",
    "cancelled": "red.6",
    "completed": "green.7",
    "confirmed": "blue.5",
    "declined": "red.4",
    "deleted": "red.7",
    "draft": "yellow.6",
    "invoiced": "blue.4",
    "noshow": "red.8",
    "offered": "orange.5",
    "paid": "green.8",
    "paid_out": "green.9",
    "talent_advancing": "green.2",
    "talent_cancelled": "red.3",
    "venue_cancelled": "red.2",
};

export const BOOKING_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "corporate_event": "blue.6",
    "house_party": "orange.5",
    "private_booking": "green.5",
    "venue_booking": "violet.6",
    "wedding": "pink.5",
};

export const DOCUMENT_ROLE_ENUM_PALETTE: Record<string, MantineColor> = {
    "agency": "blue.6",
    "area": "cyan.5",
    "booking": "green.5",
    "guideline": "violet.4",
    "talent": "pink.6",
    "venue": "orange.5",
};

export const DOCUMENT_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "active": "green.6",
    "inactive": "gray.5",
};

export const DOCUMENT_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "bio": "blue.5",
    "document": "cyan.6",
    "epk": "teal.6",
    "equipment_ryder": "lime.6",
    "hospitality_ryder": "orange.6",
    "invoice": "blue.7",
    "logo": "violet.6",
    "media": "pink.5",
    "press_pic": "grape.5",
    "w9": "gray.6",
};

export const GUIDELINE_ROLE_ENUM_PALETTE: Record<string, MantineColor> = {
    "agency_task": "blue.6",
    "area_question": "cyan.5",
    "area_task": "cyan.6",
    "info": "blue.5",
    "talent_question": "violet.5",
    "talent_task": "violet.6",
    "venue_question": "indigo.5",
    "venue_task": "indigo.6",
};

export const GUIDELINE_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "active": "green.6",
    "inactive": "gray.5",
};

export const GUIDELINE_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "agency": "green.5",
    "area": "yellow.5",
    "booking": "orange.5",
    "talent": "pink.5",
    "venue": "teal.5",
};

export const INVOICE_TARGET_ENUM_PALETTE: Record<string, MantineColor> = {
    "agency": "blue.5",
    "talent": "green.5",
    "venue": "cyan.5",
};

export const MESSAGE_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "action": "orange.5",
    "system": "blue.6",
    "text": "gray.5",
};

export const RATE_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "full": "green.5",
    "hourly": "blue.5",
};

export const TENANT_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "active": "green.6",
    "inactive": "gray.5",
};

export const TENANT_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "agency": "blue.5",
    "bar": "orange.5",
    "business": "teal.5",
    "club": "violet.5",
    "event_space": "cyan.5",
    "hospitality_group": "lime.5",
    "hotel": "pink.5",
    "restaurant": "yellow.5",
};

export const THREAD_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "closed": "gray.5",
    "open": "green.6",
};

export const THREAD_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "booking": "blue.5",
    "discussion": "violet.5",
    "dm": "cyan.5",
    "system": "gray.6",
    "talent": "orange.5",
    "venue": "teal.5",
};

export const USER_ROLES_ENUM_PALETTE: Record<string, MantineColor> = {
    "administrator": "blue.7",
    "agency_accounting_administrator": "blue.6",
    "agency_accounting_user": "blue.5",
    "agency_booker_administrator": "cyan.7",
    "agency_booker_user": "cyan.6",
    "agency_door_administrator": "teal.7",
    "agency_door_user": "teal.6",
    "agency_marketing_administrator": "violet.7",
    "agency_marketing_user": "violet.6",
    "agency_operations_administrator": "indigo.7",
    "agency_operations_user": "indigo.6",
    "agency_talent_administrator": "grape.7",
    "agency_talent_user": "grape.6",
    "guest": "gray.5",
    "superadmin": "blue.9",
    "user": "gray.4",
    "venue_accounting_administrator": "blue.4",
    "venue_accounting_user": "blue.3",
    "venue_booker_administrator": "cyan.4",
    "venue_booker_user": "cyan.3",
    "venue_door_administrator": "teal.4",
    "venue_door_user": "teal.3",
    "venue_marketing_administrator": "violet.4",
    "venue_marketing_user": "violet.3",
    "venue_operations_administrator": "indigo.4",
    "venue_operations_user": "indigo.3",
    "venue_talent_administrator": "grape.4",
    "venue_talent_user": "grape.3",
};

export const USER_STATUS_ENUM_PALETTE: Record<string, MantineColor> = {
    "active": "green.6",
    "inactive": "gray.5",
    "invited": "blue.5",
};

export const USER_TYPE_ENUM_PALETTE: Record<string, MantineColor> = {
    "accounting": "blue.5",
    "booker": "teal.5",
    "door": "orange.5",
    "marketing": "violet.5",
    "operations": "cyan.5",
    "talent": "green.5",
};
